import { JSX } from "react";

interface Props {
  className?: string;
  /** Pixel size (width and height). Default matches header guest menu button. */
  size?: number;
}

export const ThreeDotsCircleIcon = ({ className = "text-white/90", size = 16 }: Props): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className={className}
    aria-hidden
  >
    <circle cx="6.5" cy="12" r="1.8" fill="currentColor" />
    <circle cx="12" cy="12" r="1.8" fill="currentColor" />
    <circle cx="17.5" cy="12" r="1.8" fill="currentColor" />
  </svg>
);
